var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7501 7.59H10.6651L12.7201 5.475C10.6726 3.45 7.35756 3.375 5.31006 5.4C3.26256 7.4325 3.26256 10.71 5.31006 12.7425C7.35756 14.775 10.6726 14.775 12.7201 12.7425C13.7401 11.7375 14.2501 10.56 14.2501 9.075H15.7501C15.7501 10.56 15.0901 12.4875 13.7701 13.7925C11.1376 16.4025 6.86256 16.4025 4.23006 13.7925C1.60506 11.19 1.58256 6.96 4.21506 4.3575C6.84756 1.755 11.0701 1.755 13.7026 4.3575L15.7501 2.25V7.59Z",
    fill: "#646782"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRefresh);
export default __webpack_public_path__ + "static/media/ico-refresh.ecb1c22293c30aeb2a920f9f4fd1e17b.svg";
export { ForwardRef as ReactComponent };